var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutfitNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,96H344L296.07,64H151.92L104,96H72a8,8,0,0,0-8,8V472a8,8,0,0,0,8,8H376a8,8,0,0,0,8-8V104A8,8,0,0,0,376,96ZM224,168l-47-40h94Zm-96,7.18,64,69.33V416H128ZM256,416V244.51l64-69.33V416Z",
    style: {
      fill: "#515151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.27,699.84,810.85,608V488a8,8,0,0,0-8-8h-288a8,8,0,0,0-8,8V771.17l36.48,182.4a8,8,0,0,0,7.85,6.43H810.85l148-249.31A8,8,0,0,0,956.27,699.84ZM874.85,728l-64,106V688Zm-304-184h176v32h-176Zm48,96a64.11,64.11,0,0,1-48,62V640ZM597.08,896,571.27,767c62.86-8.09,111.58-61.93,111.58-127h64V896Z",
    style: {
      fill: "#515151"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904,336H848c0-95.12-69.53-174.3-160.43-189.39A8.3,8.3,0,0,0,688,144c0-8.84-14.33-16-32-16s-32,7.16-32,16a8.3,8.3,0,0,0,.43,2.61C533.53,161.71,464,240.88,464,336v56a8,8,0,0,0,8,8H904a8,8,0,0,0,8-8V344A8,8,0,0,0,904,336Zm-376.31,0a128.11,128.11,0,0,1,46.2-98.53c-7.81,29.13-12,63.17-12,98.53ZM624,336c0-34,7.24-66.87,15.53-92.45,6.45-19.89,13.43-30,17.41-34.18,4,4.14,11,14.29,17.41,34.18C682.64,269.13,688,302,688,336Zm128,0c0-34.53-4-67.78-11.46-96.45A128,128,0,0,1,784.31,336Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,832A120.13,120.13,0,0,0,352,712v-.44L264,656l-20.74-27.65a8,8,0,0,0-8.5-2.92l-164.86,45a8,8,0,0,0-5.9,7.72V888a8,8,0,0,0,8,8H464a8,8,0,0,0,8-8V832Zm-184,0H128V720l72-16,88,56.44Zm64-56a56.06,56.06,0,0,1,56,56H352Z",
    style: {
      fill: "#999"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfitNormal);
export default __webpack_public_path__ + "static/media/outfit_normal.49c8459d4594cba6c54071b28f071dcb.svg";
export { ForwardRef as ReactComponent };